import axios from "axios";

// const baseURL = "https://localhost:44329/api/";
const baseURL = process.env.API_BASE_URL;
const user = "calculadorApp";
const password = "K5LwbVH6r9QG9TvLJbvCoZgMu3fPD0UK";

export default function authenticateService() {
  const credentials = {
    usuario: user,
    password: password,
  };

  if (!sessionStorage.getItem("jwtToken")) {
    return axios
      .post(baseURL + "usuariosbackoffice/authenticate", credentials)
      .then((response) => {
        sessionStorage.setItem("jwtToken", response.data.jwtToken);
        sessionStorage.setItem("refreshToken", response.data.refreshToken);
        return response;
      })
      .catch((error) => {
        throw error;
      });
  }
}
